/* eslint max-len: "off" */
import { Tracker } from '@reverbdotcom/discovery-ui';
import * as elog from '@reverbdotcom/commons/dist/elog';
import * as Sentry from '@sentry/browser';
import { parseMeta } from './parse_meta';

const ELOG_CONFIG_KEY = 'elog-config';
const CURRENT_USER_KEY = 'current-user';

window.Sentry = Sentry;

function isBot() {
  const userConfig = parseMeta(CURRENT_USER_KEY);

  return userConfig &&
    userConfig.user &&
    userConfig.user.isBot;
}

function initializeElog() {
  const elogConfig = parseMeta(ELOG_CONFIG_KEY);

  if (elogConfig) {
    const config = Object.assign(
      {},
      elogConfig.elog,
      { sentryClient: Sentry },
    );

    elog.configure(config);
    elog.identify(config.userContext);
    Tracker.pageView();
  }
}

function init() {
  initializeElog();
}

window.addEventListener('load', () => {
  if (process.env.NODE_ENV === 'test') {
    return;
  }

  init();
});

export default {
  init, // for testing only
};



// WEBPACK FOOTER //
// ./javascripts/components/error_logger.js